<template>
  <div class="content-view">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <div class="header">
          <span>全部数据</span>
          <el-input
            class="searchDiv"
            prefix-icon="el-icon-search"
            v-model="searchValue"
            placeholder=""
            size="mini"
            @input="researchKeyWord"
          />
        </div>
      </div>
      <div class="bookInfo" v-for="(item, index) of records" :key="index">
        <div
          class="title"
          @click="goToPage(item)"
        >
          {{ item.title }}
        </div>
        <div class="content" >
          {{ item.description }}
        </div>
        <div class="contributor">
          {{ item.sourceTitle }}
        </div>
      </div>
      <el-pagination
        show-quick-jumper
        :default-current="pageIndex"
        :pageSize.sync="pageSize"
        :total="total"
        :show-total="(total) => `共${total}条记录`"
        @current-change="changeTablePage"
      />
    </el-card>
  </div>
</template>

<script>
import bookApi from '@/api/book';

export default {
  data () {
    return {
      records: [],
      currentBookType: {},
      pageIndex: 1,
      pageSize: 10,
      total: 0,
      searchValue: ''
    };
  },
  mounted () {},
  methods: {
    getData () {
      this.records = [];
      if (this.currentBookType.key === '') {
        return;
      }

      let that = this;

      bookApi
        .getBook({
         /*  path: this.currentBookType.path,
          pageindex: this.pageindex,
          pageSize: this.pageSize,
          keyWord: this.searchValue,
          libraryCode: this.global.getLibraryInfos().code */
          path: 'getBookDataWithPrs',
          pageindex: this.pageindex,
          pageSize: this.pageSize,
          bookType: 'paper',
          schemaType: this.currentBookType.key
        })

        .then((response) => {
          console.log(response);
          if (response.code === 200) {
            that.total = response.data.count;
            that.records = response.data.rows;
            // that.records.forEach(function (item, index) {
            //     that.transPdfToImage(item.pagePic, index)
            // }
            // )
           /*  if (that.records.length === 0) {
              return;
            }
              that.transPdfToImage(that.records[0].pagePic, 0); */
          }
        });
    },
    researchKeyWord () {
      // console.log(e);
      this.pageIndex = 1;
      this.getData();
    },
    changeTablePage (e) {
      this.pageindex = e;
      this.getData();
    },
    changeBookSelect (item) {
      this.searchValue = '';
      this.currentBookType = item;
      this.getData();
    },
     goToPage (item) {
      let routeData = this.$router.resolve({
        path: '/bookView',
        query: {
          bookId: item.sourceID,
          bookType: 'book',
          startPage: '001'
        }
      });

      // 必要操作，否则不会打开新页面
      window.open(routeData.href, '_blank');
    },
    transPdfToImage (pdfUrl, dataindex) {
      let that = this
			$('#imgDiv').empty();
			// function fileToDataURL (file) {
			// 	let reader = new FileReader()
			// 	reader.readAsDataURL(file)
			// 	// reader 读取文件成功的回调
			// 	reader.onload = function (e) {
			// 	return reader.result
			// 	}
			// }
			// function blobToFile (value, filename = 'file') {
			// return new window.File([value], filename, { type: value.type });
			// }

			function output () {
				var height = 0; var context; var mainCanvas; var b = 2; // b：整图缩放倍数
				var count = $('canvas').length;
				$('canvas').each(function (index, ele) {
					var canvas = document.getElementById('pdfCanvas');
					if (canvas) {
						if (index === 0) {
							mainCanvas = document.createElement('canvas');
							context = mainCanvas.getContext('2d');
							mainCanvas.width = canvas.width / b;
							mainCanvas.height = canvas.height / b * count;
							context.drawImage(canvas, 0, 0, canvas.width / b, canvas.height / b);
						} else {
							context.drawImage(canvas, 0, height, canvas.width / b, canvas.height / b);
						}
						height += canvas.height / b;
					}
				})
				if (mainCanvas) {
					// let img = dataURLtoBlob(mainCanvas.toDataURL('image/png', 1.0));
					// eslint-disable-next-line no-new
					// new Compressor(dataURLtoBlob(img), {
					// 	quality: 0,
					// 	success (result) {
					// 		console.log(result) // 处理后的文件流BLOB
					// 		let reader = new FileReader()
					// 		reader.readAsDataURL(result)
					// 		// reader 读取文件成功的回调
					// 		reader.onload = function (e) {
					// 			console.log('压缩后', reader.result);
					// 			that.pages.push(reader.result);
					// 			that.addPage(that.currentPage + 1);
					// 			$('#imgDiv').empty();
					// 			return reader.result
					// 		}
					// 	},
					// 	error (err) {
					// 	// 错误处理
					// 		console.log(err.message)
					// 	}
					// })
          that.records[dataindex].pagePic = mainCanvas.toDataURL('image/png', 0.1).replace(/[\r\n]/g, '')
          if (dataindex === that.records.length - 1) {
          } else {
            that.transPdfToImage(that.records[dataindex + 1].pagePic, dataindex + 1)
          }
					// that.bookShow = true;
				}
			}
			function openPage (pdfFile, pageNumber, context) {
				var scale = 2;
				pdfFile.getPage(pageNumber).then(page => {
					let viewport = page.getViewport(scale); // reference canvas via context
					var canvas = context.canvas;
					canvas.width = viewport.width;
					canvas.height = viewport.height;
					// 记录当前canvas的width，height
					window.wi = canvas.width;
					window.he = canvas.height;
					canvas.style.width = '100%';
					canvas.style.height = '100%';
					var renderContext = {
						canvasContext: context,
						viewport: viewport
					};
					page.render(renderContext).then(e => {
						  output();
					});
				});
			};

      if (that.records[dataindex].schemaType === 'base') {
PDFJS.getDocument(pdfUrl).then(pdf => {
				$('#imgDiv').css('border', '0'); // 清除文本、边框
				if (pdf) {
					window.pageNum = pdf.numPages;
					// $('#pagesText').text(pageNum);
					var canvas = document.createElement('canvas');
					canvas.id = 'pdfCanvas';

					$('#imgDiv').append(canvas);
					var context = canvas.getContext('2d');
					openPage(pdf, 1, context);
				}
			}
      );
      } else {
         if (dataindex === that.records.length - 1) {
          } else {
            that.transPdfToImage(that.records[dataindex + 1].pagePic, dataindex + 1)
          }
      }
		}
  }
}
;
</script>

<style lang="less" scoped>
@import "~@/styles/variables.less";
.content-view {
  // width: 900 * @uw;
  // height: 50 *@uw;
  // background: bisque;

  .header {
    width: 100%;
    height: 25 * @uh;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .search-box {
      width: 250 * @uw;
      display: flex;
      align-items: center;
    }
  }

  .searchDiv {
    width: 200 * @uw;
    // margin: 0px 0 20px 0px;
  }

  .bookInfo {
    margin-bottom: 30 * @uh;
    padding-bottom: 10 * @uh;
    border-bottom: dashed 1px rgba(0, 0, 0, 0.1);
    display: flex;

    .bookPic {
      width: 150 * @uw;
      margin: 10 * @uh;
      flex-shrink: 0;
    }

    .title {
      width: 550 * @uw;;
      color: #6d6d6d;
      font-size: 18 * @uw;
      font-weight: bold;
      margin-bottom: 10 * @uh;
      cursor: pointer;
    }

    .sumNum{
    width: 120  * @uw;
    height: 135  * @uh;
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
     flex-shrink: 0;
     float:right
}
    .sumValue{
          margin-top: 22px;
    font-size: 20px;
    color: #333;
    }

    .content {
       width: 650 * @uw;;
      font-size: 14 * @uw;
      margin-bottom: 10 * @uh;
    }

    .contributor {
      font-size: 13 * @uw;
      color: #8e8e8e;
    }
  }
}

:deep(.el-card__header) {
  color: #8d5e1a;
  font-weight: bold;
}
</style>
